import { Box, Flex, Text } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import React, { useState } from 'react';

import { Date } from '@finley-technologies/finley-types';

import { EditRecurringDateModal } from './EditRecurringDateModal';
import { EditIconButton } from 'packages/common-frontend/components/IconButton';
import { WipConfig } from 'packages/creditAgreements/ui/types';

export const RecurringDateConfigView: React.FC<{
  recurringDateConfig: Date.RecurringDate.Config;
  wipConfig?: WipConfig;
  fullPropertyKey: string;
  displayName?: string;
}> = ({
  recurringDateConfig,
  wipConfig,
  fullPropertyKey,
  displayName = 'Recurring Date',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSave = (config: Date.RecurringDate.Config) => {
    if (wipConfig) {
      wipConfig.formProps.setFieldValue(fullPropertyKey, config);
    }
    setIsOpen(false);
  };

  return (
    <Box mb="6">
      <Flex alignItems="center" mb="3">
        <Text fontWeight="bold" fontSize="large" mr="2">
          {displayName}
        </Text>
        {wipConfig?.isMutateAllowed(fullPropertyKey) && (
          <>
            <EditIconButton
              ariaLabel="edit"
              label="Edit"
              onClick={() => {
                setIsOpen(true);
              }}
            />
            <EditRecurringDateModal
              isOpen={isOpen}
              onCancel={() => setIsOpen(false)}
              onSave={onSave}
              recurringDateConfig={recurringDateConfig}
              displayName={displayName}
            />
          </>
        )}
      </Flex>

      <Editor
        defaultLanguage="json"
        value={JSON.stringify(recurringDateConfig, null, 4)}
        theme="vs-dark"
        height="15vh"
        width="1200px"
        options={{
          readOnly: true,
          fixedOverflowWidgets: true,
          minimap: { enabled: false },
        }}
      />
    </Box>
  );
};
